export const workScheduleQueryKeys = Object.freeze({
  cities: (companyId) => ['workScheduleCities', companyId],
  addressDirectory: (companyId, cityId) => [
    'workScheduleAddressDirectory',
    companyId,
    cityId,
  ],
  executers: (companyId) => ['workScheduleExecuters', companyId],
  parentSchedules: (companyId) => ['workScheduleParentSchedules', companyId],
  childSchedules: (workScheduleId) => [
    'workScheduleChildSchedules',
    workScheduleId,
  ],
  serviceNames: (companyId) => ['workScheduleServiceNames', companyId],
  serviceDetails: (workScheduleServiceNameId) => [
    'workScheduleServiceDetails',
    workScheduleServiceNameId,
  ],
  servicesWithTree: (workScheduleServiceNameId) => [
    'workScheduleServicesWithTree',
    workScheduleServiceNameId,
  ],
});
